"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Multiselect = _interopRequireDefault(require("react-widgets/lib/Multiselect"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var TagInput = function TagInput(props) {
  var field = props.field,
    form = props.form,
    label = props.label,
    availableTags = props.availableTags;
  var defaultValue = field.value || [];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label"
  }, label), /*#__PURE__*/_react["default"].createElement(_Multiselect["default"], {
    defaultValue: defaultValue,
    data: availableTags,
    value: field.value || [],
    allowCreate: true,
    onCreate: function onCreate(item) {
      if ((field.value || []).includes(item)) {
        return;
      }
      form.setFieldValue(field.name, [].concat(_toConsumableArray(field.value || []), [item]));
    },
    onChange: function onChange(selections) {
      form.setFieldValue(field.name, selections);
    }
  }));
};
TagInput.propTypes = {
  form: _propTypes["default"].object,
  field: _propTypes["default"].object,
  label: _propTypes["default"].node,
  availableTags: _propTypes["default"].array
};
TagInput.defaultProps = {
  availableTags: []
};
var _default = exports["default"] = TagInput;